<template>
  <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">Frequently Asked Questions</h1>


      <div>
        <router-link to="/admin/newfaq" class="btn btn-success rounded">Nieuwe vraag</router-link>
      </div>
    </div>
    <div class="card mb-4">
      <header class="card-header">
        <div class="row align-items-center">
          <div class="col-md-3 col-8 me-auto mb-md-0 mb-3"></div>
        </div>
      </header>
      <div class="card-body">
        <table class="table table-hover table-responsive">
          <tbody>

          <tr @click="editQuestion(q.code)" class="text-center align-middle" v-for="q in faq" :key="q.code">

            <td class="text-start">{{q.question}}</td>

            <td class="text-end">
              <button @click.stop="deleteQuestion(q.id)" type="button" class="btn btn-danger btn-icon">
                <i class="ci-trash"></i>
              </button>

            </td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  name: "AdminPages",
  methods: {
    editQuestion(code) {
      this.$router.push('/admin/faq/' + code);
    },
    deleteQuestion(id) {
      this.$store.dispatch('deleteQuestion',id);
    }
  },
  computed: {
    faq() {
      return this.$store.getters['faq'];
    },
  },
  created() {
    this.$store.dispatch('loadFAQ', true);
  },
}
</script>

<style scoped>

</style>